import React, { useState, useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const textAlignments = [
  { icon: 'align center', value: 'center' },
  { icon: 'align right', value: 'right' },
  { icon: 'align justify', value: 'justify' },
  { icon: 'align left', value: 'left' },
];

const TextAlign = props => {
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const textAlignment = useSelector(state => state.design.textAlignment);
  const [alignmentIndex, setAlignmentIndex] = useState(0);

  useEffect(() => {
    setAlignmentIndex(textAlignment ? textAlignments.map(e => e.value).indexOf(textAlignment) : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textAlignment]);

  const onToggle = e => {
    e.preventDefault();
    const nextIndex = (alignmentIndex + 1) % 4;
    setAlignmentIndex(nextIndex);

    const newStyle = {
      type: 'alignment',
      all: props.entityId !== enabledEditorId,
      value: textAlignments[nextIndex].value,
    };
    props.onChange(newStyle);
  };

  return <Button icon={textAlignments[alignmentIndex].icon} onMouseDown={onToggle} />;
};

TextAlign.propTypes = {
  entityId: PropTypes.number,
  onChange: PropTypes.func,
  ids: PropTypes.any,
  editorsState: PropTypes.any,
};

export default TextAlign;
